import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {Utilities} from '@shared/utilities/utilities.model';
import {PermissionService} from '@shared/service/permission.service';
import {UserV3Service} from '@shared/service/user-v-3.service';
import {UserV3Model} from '@shared/models/user-v-3.model';
import {DateUtilities} from '@shared/utilities/date-utilities.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {UserPermissionsModel} from '@shared/models/user-permission.model';
import {
	CLAIMS_MYALD_PROFILES,
	CROSS_PERMISSION_ACADEMY,
	PROFILE_BOOKINGS_RELIEF_MYALD,
	PUBLIC_USER_PROFILES
} from './permissions-variables';
import {Location} from '@angular/common';

@Component({
    selector: 'amd-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    subsUser: Subscription;
    userV3: UserV3Model;
    isLocalEnvironment: boolean;
    isUserLogged: boolean = false;
    isPublicMyald: boolean = false;
    isSystemUser: boolean = false;
    hasCrossAcademy: boolean = false;
    constructor(public userV3Service: UserV3Service,
        public permissionService: PermissionService,
        private appConfig: AppConfigEnvironmentService,
        public location: Location
    ) {
        DateUtilities.setMomentLocale();
        this.isLocalEnvironment = appConfig.Environment.environment === 'local';
        this.isUserLogged = !Utilities.isVoid(localStorage.getItem('accessReference'));
    }

    ngOnInit(): void {
        this.subscribeUser();
    }

    ngOnDestroy(): void {
        if (this.subsUser) {
            this.subsUser.unsubscribe();
        }
    }

    private subscribeUser() {
        this.subsUser = this.userV3Service.getUser().subscribe(
            () => {
                this.userV3Service.getCustomData().subscribe(
                    (user: UserV3Model) => {
                        this.permissionService.getUserV3Permission().subscribe(
                            (permission: UserPermissionsModel) => {
                                this.isPublicMyald = permission.hasProfile(CLAIMS_MYALD_PROFILES) || permission.hasProfile([PROFILE_BOOKINGS_RELIEF_MYALD]);
                                this.isSystemUser = permission.hasProfile(PUBLIC_USER_PROFILES);
                                this.hasCrossAcademy = permission.hasCrossPermission(CROSS_PERMISSION_ACADEMY);
                                this.userV3 = user;
                            }, error => {
                                console.error(error);
                            });
                    });
            }, error => {
                console.error(error);
            });
    }
}